import React from 'react';
import { useTranslation } from 'react-i18next';
import { smallestFontSize } from '_utils/sizes';
import HeimeText from 'Components/HeimeText';
import RowUsersDisplay from 'Components/RowUsersDisplay';
import { ExternalUserProfile } from 'types/User';

interface InterestedUsersProps {
    isLoading: boolean;
    users: ExternalUserProfile[];
}

const InterestedUsers: React.FC<InterestedUsersProps> = ({ isLoading, users }) => {
    const { t } = useTranslation();

    // Sort users with avatar first
    const imageUsers = users.sort((a, b) => (a.avatar ? -1 : b.avatar ? 1 : 0));
    const namedUsers = [...users];

    const getUsersInterestedText = () => {
        const count = users.length;
        if (count === 0) {
            return '';
        } else if (count === 1) {
            return t('activity:suggestions:one_interested', { fname: namedUsers[0].fname });
        } else if (count === 2) {
            return t('activity:suggestions:two_interested', {
                fname1: namedUsers[0].fname,
                fname2: namedUsers[1].fname,
            });
        } else if (count === 3 || count === 4) {
            const names = namedUsers
                .slice(0, -1)
                .map((user) => user.fname)
                .join(', ');
            return t('activity:suggestions:three_or_four_interested', { names, fname: namedUsers[count - 1].fname });
        } else if (count >= 5) {
            return t('activity:suggestions:many_interested', { fname: namedUsers[0].fname, count: count - 1 });
        }
        return '';
    };

    return (
        <RowUsersDisplay
            users={imageUsers}
            subtext={
                <HeimeText variant="subtitle" style={{ fontSize: smallestFontSize }}>
                    {getUsersInterestedText()}
                </HeimeText>
            }
            isLoading={isLoading}
        />
    );
};

export default InterestedUsers;
